module.exports = __webpack_public_path__ + "img/es-mb-s4.ed418e6b.png";